import type { MigrationInterface, QueryRunner } from 'typeorm'

export class AddContactsTable1741264258468 implements MigrationInterface {
  public async up(queryRunner: QueryRunner): Promise<void> {
    console.log('running migration UP (AddContactsTable1741264258468)')
    await queryRunner.query(`
            CREATE TABLE IF NOT EXISTS "contacts" (
                "id" integer PRIMARY KEY NOT NULL,
                "name" varchar,
                "saluation" varchar,
                "function" varchar,
                "phone" varchar,
                "email" varchar,
                "note" varchar,
                "picture_url" varchar,
                "project_id" integer,
                FOREIGN KEY ("project_id") REFERENCES "projects" ("id") ON DELETE CASCADE ON UPDATE CASCADE
            );
        `)
  }

  public async down(queryRunner: QueryRunner): Promise<void> {
    console.log('running migration DOWN (AddContactsTable1741264258468)')
    await queryRunner.query(`
            DROP TABLE "contacts";
        `)
  }
}
